import katex from 'katex';
const showdownKatex = () => {
  const parser = new DOMParser();
  const config = {
    displayMode: false,
    throwOnError: false,
    delimiters: [{
      left: '$$',
      right: '$$',
      display: false
    }]
  };
  return [{
    type: 'output',
    filter(html = '') {
      const wrapper = parser.parseFromString(html, 'text/html').body;
      const latexCodeBlocks = wrapper.querySelectorAll('code.latex.language-latex');
      latexCodeBlocks.forEach(elem => {
        const input = elem.textContent ?? '';
        const html = katex.renderToString(input, config);
        if (elem.parentNode) {
          (elem.parentNode as HTMLElement).outerHTML = `<p><span class="ql-formula" data-value="${input.trim()}">${html}</span></p>`;
        }
      });
      return wrapper.innerHTML;
    }
  }];
};
export default showdownKatex;